export default "__VITE_ASSET__DM20l_Cv__"